import { render, staticRenderFns } from "./default.vue?vue&type=template&id=c8d1f612&scoped=true&"
var script = {}
import style0 from "./default.vue?vue&type=style&index=0&id=c8d1f612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d1f612",
  null
  
)

export default component.exports